<template>
  <div class="flex h-full flex-col print:block">
    <div class="flex-none border-b border-gray-400 bg-gray-200 py-4 print:hidden">
      <slot name="top" />
    </div>
    <div class="flex-auto overflow-y-auto bg-gray-50 p-3 print:overflow-visible print:bg-white print:p-0">
      <slot name="body" />
    </div>
  </div>
</template>
